import { useLanguage } from "../i18n/useLanguage";
import { useNullableGroupAccountInfo } from "../stores/hooks/useNullableGroupAccountInfo";

export const useGroupName = (): null | string => {
  const group = useNullableGroupAccountInfo();
  const [language] = useLanguage();

  if (!group) {
    return null;
  }

  if (language === "fr") {
    return group.dealerGroupNameFr || group.dealerGroupName;
  }

  return group.dealerGroupName;
};

/**
 * @see docs/worklog/TW-953-dealer-group-french-name/rfc.md
 * @see docs/worklog/TW-953-dealer-group-french-name/tfc.md
 */
